<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5"> Prestação de Contas Mensal </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-tabela
                        idTabela="tblPrestacaoContasMensal"
                        :itens="prestacaoConta"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                        <template slot="botoes">
                            <b-button-group class="float-right">
                                <btn-inserir-prestacao-contas-mensal
                                    :convenio="convenio"
                                    :desativarBotao="false"
                                    class="mr-2"
                                    v-if="$temAcessoView('CONV-MEN-01')"
                                    @atualizarLista="atualizarLista()">
                                </btn-inserir-prestacao-contas-mensal>
                            </b-button-group>
                        </template>

                        <template slot="acoes" slot-scope="data">
                            <span
                                class="text-primary float-left"
                                v-if="$temAcessoView('CONV-MEN-DES-00')">
                                <prestacao-contas-final
                                    @atualizarLista="atualizarLista()"
                                    @obterConvenio="$emit('obterConvenio')"
                                    :convenio="convenio"
                                    :prestacaoMensal="data.idPrestacaoContasMensal"
                                    :nuReceitasDiversas="data.nuReceitasDiversas"
                                    :nuTotalGasto="data.nuTotalGasto"
                                    :nuTotalRendimentos="data.nuTotalRendimentos">
                                </prestacao-contas-final>
                            </span>
                            <btn-atualizar-prestacao-contas-mensal
                                :prestacao="data"
                                @atualizarLista="atualizarLista()"
                            ></btn-atualizar-prestacao-contas-mensal>
                            <span class="text-danger float-left ml-1" v-if="$temAcessoView('CONV-MEN-02')">
                                <i
                                    class="fa fa-trash fa-lg icon-button"
                                    title="Excluir"
                                    v-if="data.contemPrestacoes == false"
                                    @click.stop="confirmarExcluir(data)"
                                ></i>
                            </span>
                            <span class="text-success float-left ml-1" v-if="$temAcessoView('CONV-MEN-DES-04')">
                                <i
                                    class="fa fa-thumbs-up fa-lg icon-button"
                                    title="Aprovar"
                                    v-if="data.codSituacao == 1"
                                    @click.stop="confirmarAprovar(data)"
                                ></i>
                            </span>
                            <span class="text-danger float-left ml-1" v-if="$temAcessoView('CONV-MEN-DES-04')">
                                <i
                                    class="fa fa-thumbs-down fa-lg icon-button"
                                    title="Reprovar"
                                    v-if="data.codSituacao == 1"
                                    @click.stop="confirmarReprovar(data)"
                                ></i>
                            </span>
                            <span class="text-success float-left ml-1" v-if="$temAcessoView('CONV-MEN-DES-04')">
                                <i
                                    class="fa fa-unlock fa-lg icon-button"
                                    title="Desbloquear Lançamentos"
                                    v-if="data.lancamentosBloqueados == true"
                                    @click.stop="confirmarDesbloquear(data)"
                                ></i>
                            </span>
                            <span class="text-danger float-left ml-1" v-if="$temAcessoView('CONV-MEN-DES-04')">
                                <i
                                    class="fa fa-lock fa-lg icon-button"
                                    v-if="data.lancamentosBloqueados == false"
                                    title="Bloquear Lançamentos"
                                    @click.stop="confirmarBloquear(data)"
                                ></i>
                            </span>
                            <span>
                                <time-line-prestacao-contas-mensal
                                    :convenio="convenio"
                                    :idPrestacaoMensal="data.idPrestacaoContasMensal"
                            ></time-line-prestacao-contas-mensal>
                            </span>
                        </template>

                        <template slot="dtCompetencia" slot-scope="data">
                            <p class="text-left m-0">
                                {{ data.dtCompetencia ? $moment(data.dtCompetencia).format('MM/YYYY') : '' }}
                            </p>
                        </template>

                        <template slot="dtPrestacao" slot-scope="data">
                            <p class="text-left m-0">
                                {{ data.dtPrestacao ? $moment(data.dtPrestacao).format('DD/MM/YYYY') : '' }}
                            </p>
                        </template>

                        <template slot="nuTotalGasto" slot-scope="data">
                            <p class="text-right m-0" >
                                {{ data.nuTotalGasto | currency }}
                            </p>
                        </template>

                        <template slot="nuTotalRendimentos" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.nuTotalRendimentos | currency }}
                            </p>
                        </template>

                        <template slot="nuReceitasDiversas" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.nuReceitasDiversas | currency }}
                            </p>
                        </template>

                        <template slot="lancamentos" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.lancamentos | currency }}
                            </p>
                        </template>

                        <template slot="valorTotalRetencoes" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.valorTotalRetencoes | currency }}
                            </p>
                        </template>

                        <template slot="valorGlosado" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.valorGlosado | currency }}
                            </p>
                        </template>

                        <template slot="valorTotal" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.valorTotal | currency }}
                            </p>
                        </template>
                        <template slot="valorContraPartidaFinanceira" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.valorContraPartidaFinanceira | currency }}
                            </p>
                        </template>
                        <template slot="valorContraPartidaEconomica" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.valorContraPartidaEconomica | currency }}
                            </p>
                        </template>
                        <template slot="situacao" slot-scope="data">
                            <app-status
                                :status="data.situacao.toUpperCase()"
                            ></app-status>
                        </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import PrestacaoContasFinal from './PrestacaoContasFinal.vue'
import BtnInserirPrestacaoContasMensal from '../cadastro/prestacaoContasMensal/BtnInserirPrestacaoContasMensal'
import BtnAtualizarPrestacaoContasMensal from '../cadastro/prestacaoContasMensal/BtnAtualizarPrestacaoContasMensal'
import BtnGlosar from './prestacaoContasFinalLancamento/BtnGlosar.vue'
import TimeLinePrestacaoContasMensal from './prestacaoContasMensal/timelineoperacionalizacoes/TimeLinePrestacaoContasMensal'

export default {
    components: {
        PrestacaoContasFinal,
        BtnInserirPrestacaoContasMensal,
        BtnAtualizarPrestacaoContasMensal,
        TimeLinePrestacaoContasMensal,
        BtnGlosar
    },

    props: {
        exibirBotaoAdicionar: Boolean,
        convenio: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            erros: [],
            itensPorPagina: 5,
            prestacaoConta: [],
            justificativa: 'Justificativa',
            relatorios: [
                {
                    key: 0,
                    label: ''
                },
                {
                    key: 1,
                    label: 'F0280/5 - Demonstrativo Execução Sintetico'
                },
                {
                    key: 2,
                    label: 'F0280/6 - Relação Pagamentos Efetuados'
                },
                {
                    key: 3,
                    label: 'F0280/7 - Relação Pagamentos Efetuados Recursos Parceiro'
                },
                {
                    key: 4,
                    label: 'Extrato Prestação Contas'
                }
            ],
            relatorio: 0,
            campos: [
                {
                    key: 'dtCompetencia',
                    label: 'Competência',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtPrestacao',
                    label: 'Data Prestação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuTotalGasto',
                    label: 'Total Despesas',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'nuTotalRendimentos',
                    label: 'Total Rendimentos',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'nuReceitasDiversas',
                    label: 'Receitas Diversas',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'lancamentos',
                    label: 'Valor Conferido',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'valorGlosado',
                    label: 'Valor Glosado',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'valorTotalRetencoes',
                    label: 'Impostos',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'valorContraPartidaEconomica',
                    label: 'Contrapartidas Econômicas',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'valorContraPartidaFinanceira',
                    label: 'Contrapartidas Financeiras',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'situacao',
                    label: 'Situacao',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ]
        }
    },


    methods: {
        imprimir() {
            if (this.relatorio == 1) {
                this.$store.dispatch('addRequest')
                ConveniosServicos.RelatorioF02805DemonstrativoExecucaoSintetico(
                    this.convenio.idConvenio,
                    1
                ).then((response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao emitir relatório!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                'F02805-ComprometimentosSemRegistroPagamento.pdf'
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else if (this.relatorio == 2) {
                this.$store.dispatch('addRequest')
                ConveniosServicos.RelatorioF02806RelacaoPagamentosEfetuados(
                    this.convenio.idConvenio,
                    1
                ).then((response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao emitir relatório!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                'F02806-RelacaoPagamentosEfetuados.pdf'
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else if (this.relatorio == 3) {
                this.$store.dispatch('addRequest')
                ConveniosServicos.RelatorioF2807RelacaoPagamentosEfetuadosRecursosParceiro(
                    this.convenio.idConvenio,
                    1
                ).then((response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao emitir relatório!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                'F2807-RelacaoPagamentosEfetuadosRecursosParceiro.pdf'
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else if (this.relatorio == 4) {
                this.$store.dispatch('addRequest')
                ConveniosServicos.RelatorioExtratoPrestacaoContas(
                    this.convenio.idConvenio,
                    1
                ).then((response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao emitir relatório!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            this.$download(
                                response,
                                'ExtratoPrestacaoContas.pdf'
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                alert('Informe um Relatório.')
            }
        },

        atualizarLista() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.convenio.idConvenio).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.prestacaoConta = response.data.prestacoesContasMensal
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        confirmarExcluir(obj) {
            this.$swal({
                title: 'Excluir',
                html: 'Deseja Excluir a Prestação de Contas Mensal ? ',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir(obj.idPrestacaoContasMensal)
                }
            })
        },

        confirmarBloquear(obj) {
            this.$swal({
                title: 'Bloquear',
                html: 'Deseja Bloquear o acesso aos Lançamentos?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.bloquearLancamentos(obj)
                }
            })
        },

        confirmarDesbloquear(obj) {
            this.$swal({
                title: 'Liberar',
                html: 'Deseja Liberar o acesso aos Lançamentos?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.desbloquearLancamentos(obj)
                }
            })
        },

        confirmarAprovar(obj) {
            this.$swal({
                title: 'Aprovar',
                html: 'Deseja Aprovar a Prestação de Contas Mensal ? ',
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.aprovar(obj.idPrestacaoContasMensal)
                }
            })
        },

        confirmarReprovar(obj) {
            this.$swal({
                title: 'Reprovar',
                html: 'Deseja Reprovar a Prestação de Contas Mensal ? ',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: `Informe a Justificativa`,
                inputValidator: (value) => {
                    if (!value) {
                        return `A justificativa é obrigatória`
                    } else {
                        obj.justificativa = value
                    }
                }
            }).then((result) => {
                if (result.value) {
                    this.reprovar(obj)
                }
            })
        },

        excluir(id) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.excluirPrestacaoContaMensal(id).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.atualizarLista()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        aprovar(id) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.aprovarPrestacaoContaMensal(id).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                            'Prestação aprovada com sucesso',
                            'OK',
                            this.$toastConfig.success)
                            this.atualizarLista()
                        } else {
                            this.$toast.error(
                            'Existem lançamentos não conferidos',
                            "ERROR",
                            this.$toastConfig.error)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        bloquearLancamentos(obj) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.bloquearLancamentos(obj).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                            'Lançamento bloqueado com sucesso',
                            'OK',
                            this.$toastConfig.success)
                            this.atualizarLista()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        desbloquearLancamentos(obj) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.desbloquearLancamentos(obj).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                            'Lançamento desbloqueado com sucesso',
                            'OK',
                            this.$toastConfig.success)
                            this.atualizarLista()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        reprovar(obj) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.reprovarPrestacaoContaMensal(obj).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                            'Prestação reprovada com sucesso',
                            'OK',
                            this.$toastConfig.success)
                            this.atualizarLista()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },
    watch: {
        convenio() {
            if (this.convenio) {
                this.prestacaoConta = this.convenio.prestacoesContasMensal
            }
        }
    },
}
</script>
